module.exports = __webpack_public_path__ + "static/media/gridBlank.93b72dce.png";